import { Empty } from 'antd';

const PageNotFound = () => {
  return <Empty description='Trang không tồn tại' />;
};
export default PageNotFound;
